module.exports = "pegasus/assets/theme4/small/4.jpg";